import { DateTime } from 'luxon';

import { Timezone } from '@clearverify/constants';

export const TIMEZONE_SELECT_OPTIONS = [
  {
    id: 1,
    value: Timezone.americaAdak,
    label: Timezone.americaAdak,
  },
  {
    id: 2,
    value: Timezone.pacificHonolulu,
    label: Timezone.pacificHonolulu,
  },
  {
    id: 3,
    value: Timezone.americaAnchorage,
    label: Timezone.americaAnchorage,
  },
  {
    id: 4,
    value: Timezone.americaJuneau,
    label: Timezone.americaJuneau,
  },
  {
    id: 5,
    value: Timezone.americaMetlakatla,
    label: Timezone.americaMetlakatla,
  },
  {
    id: 6,
    value: Timezone.americaNome,
    label: Timezone.americaNome,
  },
  {
    id: 7,
    value: Timezone.americaSitka,
    label: Timezone.americaSitka,
  },
  {
    id: 8,
    value: Timezone.americaYakutat,
    label: Timezone.americaYakutat,
  },
  {
    id: 9,
    value: Timezone.americaLosAngeles,
    label: Timezone.americaLosAngeles,
  },
  {
    id: 10,
    value: Timezone.americaBoise,
    label: Timezone.americaBoise,
  },
  {
    id: 11,
    value: Timezone.americaDenver,
    label: Timezone.americaDenver,
  },
  {
    id: 12,
    value: Timezone.americaPhoenix,
    label: Timezone.americaPhoenix,
  },
  {
    id: 13,
    value: Timezone.americaChicago,
    label: Timezone.americaChicago,
  },
  {
    id: 14,
    value: Timezone.americaIndianaKnox,
    label: Timezone.americaIndianaKnox,
  },
  {
    id: 15,
    value: Timezone.americaIndianaTellCity,
    label: Timezone.americaIndianaTellCity,
  },
  {
    id: 16,
    value: Timezone.americaMenominee,
    label: Timezone.americaMenominee,
  },
  {
    id: 17,
    value: Timezone.americaNorthDakotaBeulah,
    label: Timezone.americaNorthDakotaBeulah,
  },
  {
    id: 18,
    value: Timezone.americaNorthDakotaCenter,
    label: Timezone.americaNorthDakotaCenter,
  },
  {
    id: 19,
    value: Timezone.americaNorthDakotaNewSalem,
    label: Timezone.americaNorthDakotaNewSalem,
  },
  {
    id: 20,
    value: Timezone.americaDetroit,
    label: Timezone.americaDetroit,
  },
  {
    id: 21,
    value: Timezone.americaIndianaIndianapolis,
    label: Timezone.americaIndianaIndianapolis,
  },
  {
    id: 21,
    value: Timezone.americaIndianaMarengo,
    label: Timezone.americaIndianaMarengo,
  },
  {
    id: 23,
    value: Timezone.americaIndianaPetersburg,
    label: Timezone.americaIndianaPetersburg,
  },
  {
    id: 24,
    value: Timezone.americaIndianaVevay,
    label: Timezone.americaIndianaVevay,
  },
  {
    id: 25,
    value: Timezone.americaIndianaVincennes,
    label: Timezone.americaIndianaVincennes,
  },
  {
    id: 26,
    value: Timezone.americaIndianaWinamac,
    label: Timezone.americaIndianaWinamac,
  },
  {
    id: 27,
    value: Timezone.americaKentuckyLouisville,
    label: Timezone.americaKentuckyLouisville,
  },
  {
    id: 28,
    value: Timezone.americaKentuckyMonticello,
    label: Timezone.americaKentuckyMonticello,
  },
  {
    id: 29,
    value: Timezone.americaNewYork,
    label: Timezone.americaNewYork,
  },
];

export const NOW = DateTime.now();
